import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
const TourDetailImage = ({ selectedTour }) => {
  const [wishlist, setWishlist] = useState([]);
  const { feedbacks, averageRating } = useSelector((state) => state.feedback);
  const { user } = useSelector((state) => state.auth);
  var userId = 0;
  if (user) {
    const decoded = jwtDecode(user);
    userId = decoded["sub"];
  }

  //#region handle wishlist
  useEffect(() => {
    if (user) {
      var currentUserId = userId; // Lấy user ID
      currentUserId = currentUserId ? currentUserId : 0;

      // Lấy danh sách wishlist từ localStorage
      const wishlistExist =
        JSON.parse(localStorage.getItem(`wishlist_${currentUserId}`)) || [];
      setWishlist(wishlistExist);
    }
  }, []);

  // Hàm xử lý khi click vào tour (cập nhật wishlist)
  const toggleWishlist = (tourId) => {
    if (userId === 0) {
      toast.error("Vui lòng đăng nhập để xem danh sách mong muốn!");
      return;
    }

    let updatedWishlist;

    if (wishlist.includes(tourId)) {
      updatedWishlist = wishlist.filter((id) => id !== tourId); // Xóa khỏi wishlist
      toast.info("Đã xóa khỏi danh sách yêu thích");
    } else {
      updatedWishlist = [...wishlist, tourId]; // Thêm vào wishlist
      toast.success("Đã thêm vào danh sách yêu thích");
    }

    setWishlist(updatedWishlist);
    localStorage.setItem(`wishlist_${userId}`, JSON.stringify(updatedWishlist));
    window.dispatchEvent(new Event("wishlistUpdated")); // Phát sự kiện
  };
  //#endregion

  if (!selectedTour || !selectedTour.tourDetails) return <p>Loading...</p>;

  const largeImages = selectedTour.tourDetails.flatMap((detail) =>
    detail.tourImages.map((img) => img.imageUrl)
  );

  const responsiveLarge = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  return (
    <div>
      <div className="service-wrap mb-4">
        <div className="slider-wrap vertical-slider tour-vertical-slide d-flex align-items-center">
          {/* Large Image Slider */}
          <div
            className="slider-for nav-center"
            id="large-img"
            style={{ maxWidth: "100%" }}
          >
            <Carousel
              responsive={responsiveLarge}
              autoPlay={true}
              autoPlaySpeed={3000}
              infinite={true}
              arrows={true}
            >
              {largeImages.map((img, index) => (
                <div key={index} className="service-img">
                  <img
                    src={img}
                    className="img-fluid"
                    alt={`Slider Img ${index}`}
                    style={{ width: "1284px", objectFit: "cover" }}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      {/* GIỮ NGUYÊN GIAO DIỆN */}
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="mb-2">
          <h4 className="mb-1 d-flex align-items-center flex-wrap mb-2">
            {selectedTour.tourName}
            <span className="badge badge-xs bg-success rounded-pill ms-2">
              <i className="isax isax-ticket-star me-1"></i>Verified
            </span>
          </h4>
          <div className="d-flex align-items-center flex-wrap">
            <Link to={`/category/${selectedTour.categoryId}`}>
              <p className="fs-14 mb-2 ">
                <i className="isax isax-receipt text-primary me-2"></i>
                {selectedTour.category.categoryName || "Adventure Tour"}
              </p>
            </Link>
            <div className="d-flex align-items-center mb-2">
              <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                {averageRating || "5.0"}
              </span>
              <p className="fs-14">
                <a href="#reviews">({feedbacks.length} Reviews)</a>
              </p>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <p className="fs-14 mb-2 me-3 pe-3 border-end">
              <i className="isax isax-location5 me-2"></i>
              {selectedTour.departureLocation}
              <a
                href="#location"
                className="link-primary text-decoration-underline fw-medium ms-2"
              >
                View Location
              </a>
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center mb-3">
          <a
            href="#"
            className="btn btn-outline-light btn-icon btn-sm d-flex align-items-center justify-content-center me-2"
          >
            <i className="isax isax-share"></i>
          </a>
          <a
            href="#"
            className="btn btn-outline-light btn-sm d-inline-flex align-items-center"
            onClick={(e) => {
              e.preventDefault();
              toggleWishlist(selectedTour.tourId);
            }}
          >
            <i
              className={`isax ${
                wishlist.includes(selectedTour.tourId)
                  ? "isax-heart5"
                  : "isax-heart"
              }  text-danger me-1`}
            ></i>
            Yêu thích
          </a>
        </div>
      </div>
    </div>
  );
};

export default TourDetailImage;
